<template>
  <!-- 新增推荐商品 -->
  <div class="addComm">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="推荐商品" prop="name">
            <el-input
              @click.native="addGoodName"
              v-model="addForm.name"
              placeholder="请输入商品名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="位置类型" prop="recommPosition">
            <el-select
              v-model="addForm.recommPosition"
              placeholder="位置类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
              <!-- <el-option label="购物车" value="0"></el-option>
          <el-option label="结算成功" value="1"></el-option> -->
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="addForm.status"
              placeholder="状态"
              style="width: 100%"
            >
              <el-option label="已上架" value="1"></el-option>
              <el-option label="已下架" value="0"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="排序" prop="sort">
            <el-input v-model="addForm.sort" clearable></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
    <!-- 绑定商品dialog -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="ouZone">
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm2.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="goodData"
        stripe border
        @row-click="rowClick"
        @selection-change="selectionChange"
        tooltip-effect="dark"
        style="width: 100%;height: 500px;overflow: auto;"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage2 - 1) * pageSize2 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" align="center" width="55">
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="keyid"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="sub_title"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_spec"
          label="商品规格"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price_ck"
          label="建议零售价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="stock_quantity"
          label="库存"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_factory"
          label="生产厂家"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="big_package"
          label="件装量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项
export default {
  name: "addComm",
  data() {
    return {
      /**新增表单 */
      //推荐商品 位置类型 状态 排序
      dialogVisible: false,
      currPage2:1,
      pageSize2:20,
      allPage2:0,
      goodData: [],
      options: [],
      addForm: {
        name: "",
        id: "",
        gg: "",
        sccj: "",
        zbz: "",
        kc: "",
        je: "",
        recommPosition: "",
        status: "1",
        sort: "0",
      },
      /**搜索表单 */
      searchForm2: {
        name: "",
      },
      /**新增表单规则 */
      addFormRule: {
        name: [{ required: true, message: '该字段为必填项' }],
        id: [],
        gg: [],
        sccj: [],
        zbz: [],
        kc: [],
        je: [],
        recommPosition: [mustFill],
        status: [mustFill],
        sort: [mustFill],
      },
    };
  },
  components: {},
  created: function () {
    this.LoadImgType()
    this.getTableData()
  },
  methods: {
     /**重置*/
    resetForm() {
      this.$refs.addForm.resetFields()
    },
     //获取分类
    LoadImgType() {
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx",
        data: { "json": "{'type':'GoodsRecommendType'}", "type": "GoodsRecommendType", "proc": "" },
        method: "Post",
      }).then((res) => {
        this.options = res.data
      }).catch((err) => {
        window.console.log(err)
      })
    },
    addGoodName() {
      this.dialogVisible = true
    },
    /**获取表格 */
    getTableData() {
      // this.$store.commit('handleLoding')
      var strWhere = this.searchForm2.name
      var pageIndex = this.currPage2
      var pageSize = this.pageSize2
      var type = "ReturnDataSet"
      var proc = "Proc_Admin_SearchInfo"
      var data = {
        type: 'GoodsListHG',
        strWhere: strWhere,
        pageIndex: pageIndex,
        pageSize: pageSize
      }
      this.$requestSys({
        url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + encodeURIComponent(type) + "&proc=" + encodeURIComponent(proc),
        method: "Post",
      }).then((res) => {
        if (res.flag == 0) {
          this.goodData = res.content
          this.allPage2 = res.recordCount
        } else {
          if(pageSize==1){
            this.goodData = []
          }
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    rowClick(row){
      this.row = row
      this.addForm.name = row.sub_title
      this.addForm.id = row.keyid
      this.addForm.gg = row.drug_spec
      this.addForm.sccj = row.drug_factory
      this.addForm.zbz = row.min_package
      this.addForm.kc = row.stock_quantity
      this.addForm.je = row.price_ck
      this.dialogVisible = false
    },
      /**分页size改变 */
    hanSiChange2(val){
      this.pageSize2 = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange2(val){
      this.currPage2 = val
      this.getTableData()
    },
     /**selection change触发事件 */
    selectionChange(section){
      //存放选中的表格数据
      this.selectedList = section
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1)
      this.$destroy()
    },
    submit(){
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          var articleid = this.addForm.id
          var type = this.addForm.recommPosition
          var status = this.addForm.status
          var sort = this.addForm.sort
          this.$requestSys({
            url: "goods/ashx/ReturnJson.ashx",
            data:{ "json": "{'type':'AddGoodsRecommend','articleid':'" + articleid + "','code':'" + type + "','status':'" + status + "','sort':'" + sort + "'}", "type": "AddGoodsRecommend", "proc": "" },
            method: "Post",
          }).then((res) => {
            if (res.flag == 1) {
              this.$message({
                message: "添加成功",
                type: "success",
              })
              this.$router.go(-1)
            } else {
              this.$message({
                message: res.message,
                type: "info",
              })
            }
          }).catch((err) => {
            window.console.log(err)
          })
        }
      })
    },
    /**图片成功上传回调 */
    imgFallback(url) {
      this.addForm.image = url
    },
  },
}
</script>

<style scoped>
.addComm {
  width: 100%;
  height: 100%;
}
.form-item-wrap {
  display: flex;
  padding: 0 0 0 20px;
  box-sizing: border-box;
}
.ouZone {
  float: right;
}
</style>
